import '../css/main.css';
import '../css/Community.css'

import {MainMenu} from "./MainMenu";
import discord_logo from "../images/discordlogo.png";
import minecraft_logo from "../images/minecraftlogo.png";

export function Community() {
    return (
        <div className="App">

            <div className="App-center">
                <section class="SplitScreen">
                    <div id="discord-col">
                        <h2><img src={discord_logo} className="CommunityLogo" alt="logo" /></h2>
                        <h1>Antimony Development Discord</h1>
                        Our Official public Discord Server can be found <a href="https://discord.gg/RAf57BbgTA"> here</a>. If you're looking for the most up-to-date information on new projects, this is where to be! We also host events!
                    </div>
                    <div id="minecraft-col">
                        <h2><img src={discord_logo} className="CommunityLogo" alt="logo" /></h2>
                        <h1>Antique Penguin Discord</h1>
                        Antique Penguin's public Discord Server can be found <a href="https://discord.gg/3f6arcH"> here</a>. Join for sneak peeks, new update notifications, and just to chat with the greater Antique Penguin community!
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Community();